import axiosClient from './axiosClient';

type IReqBody = {
  bookingNumber: string;
  base64document: string;
  name: string;
  type: number;
};

async function uploadDocument(bodyRequest: IReqBody) {
  try {
    const response = await axiosClient.post('/documents/uploadDocument', bodyRequest);

    if (response.status !== 200) {
      console.warn(`api call response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default uploadDocument;
